globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.ShowMediaImage = (function(superClass) {

  utils.extend(ShowMediaImage, superClass);

  ShowMediaImage.ajaxResourcePath = "/configuration/mediatheque/images";

  function ShowMediaImage() {
    return ShowMediaImage.__super__.constructor.apply(this, arguments);
  }

  $.extend(ShowMediaImage.prototype, {
    init: function() {
      var modal = this;

      modal._initEvents();

      return ShowMediaImage.__super__.init.apply(this, arguments);
    },
    _initEvents: function() {
      var modal = this;

      modal.$html.on('click', '.remove-folder-item', function(){
        var $this = $(this),
            $folder_file = $this.closest('.folder-item');
        bootbox.confirm({
          message: "Voulez-vous vraiment supprimer l'image de ce dossier ?",
          buttons: {
            confirm: {
              label: "Confirmer",
              className: "btn btn-primary float-right mr-10",
            },
            cancel: {
              label: "Annuler",
              className: "btn btn-default float-right",
            }
          },
          callback: function(result) {
            if(result) {
              modal._removeFolderFile($folder_file);
            }
            this.hide();
          }
        });
      });

      modal.$html.on('click', '.new-folder-item', function(){
        $(this).addClass('loading').tooltip('hide');
      });
    },
    _removeFolderFile: function($folder_file) {
      var modal = this,
          id = $folder_file.data('id'),
          payload = {
            _method: 'patch',
            accounts_media_image: {
              folder_files_attributes: {
                _destroy: true,
                id: id
              }
            }
          };

      $.post(ShowMediaImage.ajaxResourcePath + '/' + modal._getImageUniqKey(), payload, function(data) {
        $folder_file.fadeOut(90, function(){
          $folder_file.remove();
        })
      });
    },
    _getImageUniqKey: function(){
      return this.$html.data('uniq-key');
    }
  });

  return ShowMediaImage;

})(appCustomerSpace.Modal);
